import { createPinia } from 'pinia'
import { acceptHMRUpdate, defineStore } from 'pinia'
// import { ILeague } from '@/types/general'
import AccountService from '@/services/account.service'

// CJS - much of the code commented out below was experimetal to get the showRules funcitionality needed in TenantNavbar.vue
// CJS - I was able to get data, but the results were always in a PromiseResponse (this has to do with async/await), but I never got it working

//import { currentSubdomain } from '@/utils/helpers/urlHelpers'

// export const pinia = createPinia()


//interface IState {
//  rules_text: string
//}

//const initialState: IState = { rules_text:
//  AccountService.fetchBySubdomain(currentSubdomain()).then(
//    (response: AxiosResponse) => {
//      return Promise.resolve(response.data.rules_text)
//      },
//    (error) => {
//      return Promise.reject(error)
//    }
//  ),
//}


export const useAccountStore = defineStore('account.store', {
  // state: (): IState => ({ ...initialState }),
//  getters: {
//    showRules: (state: IState) => {
//      console.log('accountStore:state.rules_text:', state.rules_text)
//      return state.rules_text != null
//    }
//  },
  getters: {},
  actions: {
    fetch(accountId) {
      console.log('accountStore fetch...', accountId)
      return AccountService.fetch(accountId)
    },

    fetchAll() {
      console.log('accountStore fetchAll...')
      return AccountService.fetchAll()
    },

    fetchAllForUser(userId) {
      console.log('accountStore fetchAllForUser...', userId)
      return AccountService.fetchAllForUser(userId)
    },

    fetchBySubdomain(subdomain) {
      return AccountService.fetchBySubdomain(subdomain)
    },

    create(newLeague: ILeague) {
      console.log('accountStore create...', newLeague)
      return AccountService.create(newLeague)
    },

    sendUSSSARosters(accountId) {
      return AccountService.sendUSSSARosters(accountId)
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountStore, import.meta.hot))
}
